import React from "react";
import { ArrowRight, Server, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function PricingCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="pricing-call-to-action" className="bg-background text-foreground py-24 px-4 md:px-8 dark:bg-background dark:text-foreground">
      <div ref={ref} className={cn("max-w-5xl mx-auto transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <Card className="bg-card border-border shadow-2xl overflow-hidden rounded-2xl">
          <CardContent className="p-0">
            <div className="flex flex-col md:flex-row items-stretch">
              {}
              <div className="flex-1 p-8 md:p-12 flex flex-col justify-center border-b md:border-b-0 md:border-r border-border bg-card/50 relative overflow-hidden">
                {}
                <div className="absolute top-0 left-0 w-full h-full bg-primary/5 pointer-events-none" />
                
                <div className="relative z-10">
                  <span className="inline-block text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-2">
                    Total Investment
                  </span>
                  <div className="flex items-baseline gap-2 mb-1">
                    <span className="text-5xl md:text-6xl font-bold text-primary tracking-tight">
                      $995
                    </span>
                    <span className="text-2xl md:text-3xl text-muted-foreground font-normal">
                      + GST
                    </span>
                  </div>
                  
                  {}
                  <div className="mt-8 bg-muted/40 border border-border rounded-xl p-5 flex items-center gap-4 max-w-md backdrop-blur-sm">
                    <div className="bg-background p-2.5 rounded-lg border border-border/50 shadow-sm shrink-0">
                      <Server className="w-5 h-5 text-primary" />
                    </div>
                    <div>
                      <p className="text-foreground font-semibold text-base">
                        Hosting & Maintenance
                      </p>
                      <p className="text-muted-foreground text-sm">
                        $39 per month + GST
                      </p>
                    </div>
                  </div>

                  {}
                  <div className="mt-4 bg-muted/40 border border-border rounded-xl p-5 flex items-center gap-4 max-w-md backdrop-blur-sm">
                    <div className="bg-background p-2.5 rounded-lg border border-border/50 shadow-sm shrink-0">
                      <Check className="w-5 h-5 text-primary" />
                    </div>
                    <div>
                      <p className="text-foreground font-semibold text-base">
                        Testimonials Section
                      </p>
                      <p className="text-muted-foreground text-sm">
                        Included in package
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div className="flex-1 p-8 md:p-12 flex flex-col justify-center items-start bg-gradient-to-br from-card to-muted/10">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-foreground tracking-tight">
                  Ready to Start?
                </h2>
                <p className="text-muted-foreground mb-8 text-lg leading-relaxed max-w-sm">
                  Launch your professional online presence with our comprehensive Starter Package today.
                </p>
                
                <Button asChild size="lg" className="rounded-full text-base px-8 h-14 bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_25px_rgba(61,193,188,0.25)] hover:shadow-[0_0_35px_rgba(61,193,188,0.4)] transition-all duration-300 w-full md:w-auto cursor-pointer">
                  <Link to="/ContactPage">
                    Start My Website
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}